import PeriodSalesForm from './PeriodSalesForm';

export default PeriodSalesForm;
